export function present(val) {
  return val.trim().length > 0
}
